import api from './api';

export const shippingService = {
  /**
   * Quote shipping for a destination + method + cart subtotal.
   * Returns: { shipping_cost, cod_surcharge, eta_days_min, eta_days_max,
   *            free_shipping_applied, free_shipping_threshold, zone, district }
   */
  getQuote: async ({ districtId, method = 'standard', subtotal = 0, paymentMethod = null }) => {
    const params = {
      district_id: districtId,
      method,
      subtotal,
    };
    if (paymentMethod) params.payment_method = paymentMethod;
    const response = await api.get('/public/shipping/quote', { params });
    return response.data?.data;
  },
};
